  $(document).on('click', '.cart-remove-button', function() {
    // Check if this is the last product in the cart
    if ($('.cart-item').length === 1) {
        // Close the cart drawer
        $('.drawer__close').trigger('click');
        // Redirect to the #get-started page after the drawer closes
        setTimeout(function() {
            window.location.href = '#get-started';
        }, 300); // Adjust delay based on drawer animation timing
    }
});
$(document).on('click', '.primary-start-creating', function() {
    console.log($('.drawer__close').trigger('click'));
    $('.drawer__close').trigger('click');
});
$(document).ready(function(){
	$('.header__inline-menu a[href^="#"]').on('click',function (e) {
	    e.preventDefault();
	    var target = this.hash;
	    var $target = $(target);
	    $('html, body').stop().animate({
	        'scrollTop': $target.offset().top
	    }, 900, 'swing', function () {
	        // window.location.hash = target;
	    });
	});

    


  $('.customer.contact-field #AddressCountryNew option:first-child').val('');


  $('#HeaderDrawer-start-creating').on('click', function(e) {
     $( ".header__icon span").trigger( "click");    
  })


  function getQueryStringParameters() {
         var parameters = {}, hash;
         var q = document.URL.split('?')[1];
         if(q != undefined) {
             q = q.split('&');
             for(var i = 0; i < q.length; i++) {
                 hash = q[i].split('=');
                 parameters[hash[0]] = hash[1];
             }
         }
         return parameters;
      }
      
      function isEmpty(obj) {
       for(var key in obj) {
       if(obj.hasOwnProperty(key))
       return false;
       }
       return true;
      }

    var parameters = getQueryStringParameters();
       if(isEmpty(parameters) == false) {
       $.each(parameters, function(key, value) {
       console.log(value);
         if(value == 'true#ContactForm'){
          setTimeout(function() {
            $('html, body').animate({
              scrollTop: $('h2.form-status.form-status-list.form__message').offset().top - 250
            }, 1000);
          }, 500); // Delay to allow page reload
         }
         
       });
     }
  
});
